import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterArticle_template} from "./filterArticle_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterUser_template} from "./filterUser_template";

declare var ko: any;

export class usersProfile_template extends vnTemplate {


    protected getTemplateHtml(): string {

        return `
                <article class="c-user-profil">
                    <div class="c-user-picture">
                        <!--<svg height="200" width="200">
                            <circle cx="100" cy="100" r="96" stroke="#FF4F68" stroke-width="8"fill="#f2f2f2" />
                        </svg>-->
                        <div class="c-user-i-container"></div>
                    </div>
                    <div class="c-user-infos">
                        <div>
                            <div class="user-edit"><i class="far fa-edit"></i> Edit Profile</div>
                            <div class="user-name">Matt Hardy</div>
                            <div class="user-email">qbontuyan@open-look.com</div>
                            <div class="user-flex user-rb">
                                <div class="u-role">Writer</div>
                                <div class="u-role">Website Manager</div>
                                <div class="u-brands"></div>
                            </div>
                            <nav>
                                <li id="u-articles">Articles</li>
                                <li id="u-payments">Payment</li>
                                <li id="u-rates">Rates</li>
                            </nav>
                        </div>
                        <div class="c-user-infos-list">
                            <ul>
                                <li><i class="fal fa-money-check-edit-alt"></i>Method : Paypal</li>
                                <li><i class="fas fa-user"></i>queenie.bontuyan</li>
                                <li><i class="fab fa-paypal"></i>qbontuyan@open-look.com</li>
                            </ul>
                            <ul>
                                <li><i class="fal fa-map-marker-alt"></i>123 John street over the palm tree</li>
                                <li><i class="fal fa-city"></i>Fort-Lauderdale</li>
                                <li><i class="fal fa-flag-alt"></i>United States of America</li>
                            </ul>
                        </div>
                    </div>
                </article>
                
                <!-- Articles Performance -->
                <article class="user-dashboard">
                    <div class="d-header">
                        <div class="d-header-title">
                            <i class="fal fa-file-alt"></i>
                            <div>
                                <div class="d-section">Article performances</div>
                                <div class="d-legend">Initial 30-Day Performance Report</div>
                            </div>
                        </div>
                        <div class="d-header-specs">
                            <div class="d-header-cta"><i class="fal fa-calendar-alt"></i>From<i class="fal fa-angle-down"></i></div>
                            <div class="d-header-cta"><i class="fal fa-calendar-alt"></i>To<i class="fal fa-angle-down"></i></div>
                            <div class="d-header-cta">Brands<i class="fal fa-angle-down"></i></div>
                            <div class="d-header-cta">Network categories<i class="fal fa-angle-down"></i></div>
                            <div class="d-header-cta">Content types<i class="fal fa-angle-down"></i></div>
                            <input class="d-header-cta" placeholder="Article Search" />
                            <div class="d-header-cta">Order by<i class="fal fa-angle-down"></i></div>
                        </div>
                        
                        <div class="d-header-pagination">
                            <div class="d-header-cta activate">1</div>
                            <div class="d-header-cta">2</div>
                            <div class="d-header-cta">3</div>
                            <div class="d-header-cta">Last</div>
                        </div>
                        
                    </div>
                    <div class="d-content d-article">
                    
                        <div class="list-card card-article">
                            <div class="main-info">
                                <div class="info-highlight"><i class="fal fa-eye"></i>396</div>
                                <div class="list-brand"></div>
                            </div>
                            <div class="card-list-complement"><span class="info-highlight">List</span> Published on 2021-02-28</div>
                            <div class="card-list-title article-title">17 Celebrity Moms who are (successfully) Raising A Child Solo</div>
                            <div class="card-list-complement"><span>Network Category</span> Celebrity</div>
                        </div>
                        
                    </div>
                </article>
                
                <!-- RATES -->
                <article class="user-dashboard">
                    <div class="d-header">
                        <div class="d-header-title">
                            <i class="far fa-sliders-v"></i>
                            <div class="d-section">Rates</div>
                            <div class="d-legend" style="padding-left: 24px;"><span class="highlight">Green rates</span> have not been modified yet<br><span>Grey rates</span> have been modified and can still be edited</div>
                        </div>
                        <div class="d-header-specs">
                            <div class="d-header-cta">Brands<i class="fal fa-angle-down"></i></div>
                            <div class="d-header-cta no-border">Edit rates<i class="far fa-edit"></i></div>
                        </div>
                    </div>
                    <div class="d-content d-rates">
                        <div class="small-card">
                            <div class="card-header">
                                <div class="card-list-title">Rates_Type</div>
                            </div>
                            <div class="card-info">
                                <div>
                                    <div class="card-list-info">Article commission</div>
                                    <div class="d-rate edited">99.000</div>
                                </div>
                                <div>
                                    <div class="card-list-info">Article commission</div>
                                    <div class="d-rate">99.000</div>
                                </div>
                                <div>
                                    <div class="card-list-info">Article commission</div>
                                    <div class="d-rate">99.000</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
                
                <!-- Payments -->
                <div class="d-payment-grid">
                
                    <article class="user-dashboard">
                        <div class="d-header">
                            <div class="d-header-title">
                                <i class="fal fa-file-invoice-dollar"></i>
                                <div>
                                    <div class="d-section">Payment slips</div>
                                </div>
                            </div>
                            <div class="d-header-specs">
                                <div class="d-header-cta">Brands<i class="fal fa-angle-down"></i></div>
                            </div>
                            <div class="d-header-pagination">
                                <div class="d-header-cta activate">1</div>
                                <div class="d-header-cta">2</div>
                            </div>
                        </div>
                        <div class="d-content d-payment-slip">
                            <div class="small-card">
                                <div class="card-header"><i class="fal fa-calendar-check"></i> 2020-09-15</div>
                                <div class="card-info">
                                    <div>
                                        <div class="info-highlight">$999<sup>99</sup></div>
                                        <div>
                                            <a class="p-icon active"><i class="fal fa-eye"></i></a>
                                            <a class="p-icon"><i class="far fa-arrow-to-bottom"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="small-card">
                                <div class="card-header"><i class="fal fa-calendar-check"></i> 2020-09-15</div>
                                <div class="card-info">
                                    <div>
                                        <div class="info-highlight">$999<sup>99</sup></div>
                                        <div>
                                            <a class="p-icon active"><i class="fal fa-eye"></i></a>
                                            <a class="p-icon"><i class="far fa-arrow-to-bottom"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="small-card">
                                <div class="card-header"><i class="fal fa-calendar-check"></i> 2020-09-15</div>
                                <div class="card-info">
                                    <div>
                                        <div class="info-highlight">$999<sup>99</sup></div>
                                        <div>
                                            <a class="p-icon active"><i class="fal fa-eye"></i></a>
                                            <a class="p-icon"><i class="far fa-arrow-to-bottom"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    
                    <article class="user-dashboard">
                        <div class="d-header">
                            <div class="d-header-title">
                                <i class="fal fa-piggy-bank"></i>
                                <div>
                                    <div class="d-section">Pending Transactions</div>
                                    <div class="d-legend">Next Payment Date: February 16, 2021</div>
                                </div>
                            </div>
                            <div class="d-header-specs">
                                <div class="d-header-cta">Brands<i class="fal fa-angle-down"></i></div>
                                <div class="d-header-cta"><i class="fal fa-check"></i>Show all pending</div>
                            </div>
                            <div class="d-header-pagination">
                                <div class="d-header-cta activate">1</div>
                                <div class="d-header-cta">2</div>
                                <div class="d-header-cta">3</div>
                                <div class="d-header-cta">Last</div>
                            </div>
                        </div>
                        <div class="d-content d-payment-pending">
                            <div class="payment-list">
                            
                                <div class="p-list-legend">
                                    <div>&nbsp;</div>
                                    <div class="payment-info">Name<i class="fal fa-angle-down active"></i></div>
                                    <div class="payment-date">Schedule Date<i class="fal fa-angle-down"></i></div>
                                    <div class="payment-amount">Amount<i class="fal fa-angle-down"></i></div>
                                </div>
                                
                                <div>
                                    <div class="p-list-brand"><img src="" alt="" /></div>
                                    <div class="payment-info">
                                        <div class="card-list-title">Payment of Commission for writer on article</div>
                                        <div class="card-list-complement">Punky Brewster: The Good Doctor Star to Play Cherie’s Girlfriend on Peacock Series</div>
                                    </div>
                                    <div class="payment-date">2021-02-28</div>
                                    <div class="payment-amount">9999.99</div>
                                </div>
                                <div>
                                    <div class="p-list-brand"><img src="" alt="" /></div>
                                    <div class="payment-info">
                                        <div class="card-list-title">Payment of Commission for writer on article</div>
                                        <div class="card-list-complement">Punky Brewster: The Good Doctor Star to Play Cherie’s Girlfriend on Peacock Series</div>
                                    </div>
                                    <div class="payment-date">2021-02-28</div>
                                    <div class="payment-amount">9999.99</div>
                                </div>
                                <div>
                                    <div class="p-list-brand"><img src="" alt="" /></div>
                                    <div class="payment-info">
                                        <div class="card-list-title">Payment of Commission for writer on article</div>
                                        <div class="card-list-complement">Punky Brewster: The Good Doctor Star to Play Cherie’s Girlfriend on Peacock Series</div>
                                    </div>
                                    <div class="payment-date">2021-02-28</div>
                                    <div class="payment-amount">9999.99</div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="d-footer d-payment-pending">Total Pendings <i class="fal fa-long-arrow-right"></i> <span>$9999.99</span></div>
                    </article>
                
                </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "usersProfileNew-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;

        return {

        }
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfileNew_template.ts